export default "__VITE_ASSET__9e42c706__"